import React from "react";
import {
  IconAppsGrey,
  IconIconLocalPostOfficeGrey,
  IconIconFolderManagedGrey,
  IconIconAnalyticsGrey,
  IconIconContentPasteSearchWhite,
} from "assets/svg";
import { Link } from "react-router-dom";

const MenuBottomMobileAdmin = () => {
  return (
    <div className="fixed left-1/2 -translate-x-1/2 md:hidden flex w-[335px] h-[60px] p-[10px] justify-center items-center gap-[8px] bottom-[15px] rounded-[27px] border-[2px] border-white bg-background-light shadow-soft backdrop-blur-[5px] z-[9]">
      {/*Menu Item*/}
      <div className="flex flex-col justify-center items-center shrink-0 w-[54px] h-[54px] gap-[-2px] rounded-[24px]">
        <Link to="/admin/dashboard">
          <IconAppsGrey className="w-[30px] h-[30px] shrink-0 aspect-[1/1]" />
          <div className="self-stretch text-center text-[9px] font-bold leading-[160%] text-primary font-['Noto Sans JP']">
            ボード
          </div>
        </Link>
      </div>
      {/*Menu Item*/}
      <div className="flex flex-col justify-center items-center shrink-0 w-[54px] h-[54px] gap-[-2px] rounded-[24px]">
        <Link to="/admin/company-management">
          <IconIconFolderManagedGrey className="w-[30px] h-[30px] shrink-0 aspect-[1/1]" />
          <div className="self-stretch text-center text-[9px] font-bold leading-[160%] text-primary font-['Noto Sans JP']">
            ユーザー管理
          </div>
        </Link>
      </div>
      {/*Menu Item*/}
      <div className="flex w-[54px] h-[54px] flex-col justify-center items-center gap-[-2px] flex-shrink-0 rounded-[24px] bg-primary">
        <Link to="/admin/review-company">
          <IconIconContentPasteSearchWhite className="w-[30px] h-[30px] shrink-0 aspect-[1/1]" />
          <div className="self-stretch text-center text-[9px] font-bold leading-[160%] text-white font-['Noto Sans JP']">
            審査
          </div>
        </Link>
      </div>
      {/*Menu Item*/}
      <div className="flex flex-col justify-center items-center shrink-0 w-[54px] h-[54px] gap-[-2px] rounded-[24px]">
        <IconIconAnalyticsGrey className="w-[30px] h-[30px] shrink-0 aspect-[1/1]" />
        <div className="self-stretch text-center text-[9px] font-bold leading-[160%] text-primary font-['Noto Sans JP'] opacity-[0.2]">
          レポート
        </div>
      </div>
      {/*Menu Item*/}
      <div className="flex flex-col justify-center items-center shrink-0 w-[54px] h-[54px] gap-[-2px] rounded-[24px]">
        <Link to="/admin/conversation-inquiry">
          <IconIconLocalPostOfficeGrey className="w-[30px] h-[30px] shrink-0 aspect-[1/1]" />
          <div className="self-stretch text-center text-[9px] font-bold leading-[160%] text-primary font-['Noto Sans JP']">
            お問い合わせ
          </div>
        </Link>
      </div>
    </div>
  );
};

export default MenuBottomMobileAdmin;
